export default async function FetchAthletes(sport, stat = false) {
  const currentURL = window.location.href;
  const ext = currentURL.includes("test") ? "test" : "com";
  const uid = ($('#uid').length ? $('#uid').val() : (typeof dataLayer_content !== 'undefined' && dataLayer_content.visitorId)) || 0;

  const route = stat
    ? `athletes/v1/${sport}/${stat}/${uid}`
    : `athletes/v1/${sport}/${uid}`;

  const url = `/wp-json/${route}`; // Use relative URL

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching athletes:', error);
    return null;
  }
}
